import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { User } from '../../authentication/model/user.model';
import { UserCreation, UserUpdate } from '../model/user-creation.model';
import { RoleFullDto } from '../../authentication/model/role.model';
import { ContextValues } from '../model/context-values.model';

export const USER_BASE_URI = `${environment.apiUrl}/users`;
export const ROLE_BASE_URI = `${environment.apiUrl}/role`;
export const CONTEXT_VALUES_BASE_URI = `${environment.apiUrl}/user-context-values`;

@Injectable({
  providedIn: 'root',
})
export class UserAdminService {
  constructor(private readonly http: HttpClient) {}

  createNewUser(newUser: UserCreation): Observable<void> {
    return this.http.post<void>(`${USER_BASE_URI}`,  newUser);
  }

  updateUser(user: UserUpdate): Observable<UserUpdate> {
    return this.http.put<UserUpdate>(`${USER_BASE_URI}/${user.id}`, user);
  }

  fetchAllUsers(): Observable<User[]> {
    return this.http.get<User[]>(`${USER_BASE_URI}`);
  }

  setUserStatus(userId: number, enabled: boolean): Observable<void> {
    const params = new HttpParams().append('enabled', enabled.toString());
    return this.http.put<void>(`${USER_BASE_URI}/${userId}/status`, null, { params });
  }

  fetchAllRoles(): Observable<RoleFullDto[]> {
    return this.http.get<RoleFullDto[]>(`${ROLE_BASE_URI}/admin/list-all`);
  }

  fetchContextValues(roleCode: string): Observable<ContextValues[]> {
    return this.http.get<ContextValues[]>(`${CONTEXT_VALUES_BASE_URI}/context-values/${roleCode}`);
  }
}
